import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { ACCESS } from '@/features/access/access';
import { requireRoleAccess } from '@/features/access/role-route-guard';

/**
 * Bulk Warmup Settings — applies a sparse warmup-settings patch to a selection
 * of accounts. The selection is handed off transiently via
 * `bulk-warmup-settings-store`; the page redirects back to `/email-accounts`
 * when that store is empty (a deep-link or reload has no selection to act on),
 * so this route takes no search params and primes no loader.
 */
export const emailAccountsBulkWarmupSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/email-accounts/bulk-warmup-settings',
  beforeLoad: requireRoleAccess(ACCESS.accountCreate),
  component: lazyRouteComponent(
    () => import('@/features/email-accounts/BulkWarmupSettingsPage'),
    'BulkWarmupSettingsPage',
  ),
});
